/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CaptchaResponse } from '../models/CaptchaResponse';
import { request as __request } from '../core/request';

export class CaptchaService {

    /**
     * @param query
     * @returns CaptchaResponse OK
     * @throws ApiError
     */
    public static async captchaValidate(
        query?: string,
    ): Promise<CaptchaResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/captcha`,
            query: {
                'query': query,
            },
        });
        return result.body;
    }

}